/* eslint-disable */
/* prettier-ignore */
/* This file is exported! DO NOT CHANGE! */

export const DP_ADMIN = {
FE_SERVICE_STAT_STATE_PROD: 'prod',
FE_SERVICE_STAT_STATE_WARN: 'warn',
FE_SERVICE_STAT_STATE_TEST: 'test',
FE_SERVICE_STAT_STATE_UNKNOWN: 'unknown',
FE_STAT_SEVERITY: {"prod":3,"warn":2,"test":1,"unknown":0},
}
